module.exports = __webpack_public_path__ + "img/hairdreams-logo-white.webp";